<div>
  <app-head-user (onChange)="handleChange($event)"></app-head-user>
</div>
<div>
  <app-users-list></app-users-list>
</div>
